import "./style.scss";
import { SubmitHandler, useForm } from "react-hook-form";
import { useRef, useState } from "react";
import { Clip } from "@/src/svg/Clip";
import { File } from "@/src/svg/File";
import { Delete } from "@/src/svg/Delete";
import "react-phone-input-2/lib/style.css";
import { PhoneInputController } from "../PhoneInputController/PhoneInputController";
import axiosInstance from "@/src/api/axiosInstance";
import FormSuccess from "../FormSuccess/FormSuccess";

interface IOnSubmit {
  text: string;
  name: string;
  phone: string;
  email: string;
  files: File[];
}

const LeaveForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    control,
    reset,
  } = useForm<IOnSubmit>();
  const [stateFormSuccess, setStateFormSuccess] = useState<boolean>(false);
  const [formData, setFormData] = useState<IOnSubmit>();
  const [popUpBool, setPopUpBool] = useState<boolean>(false);
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);

  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newFiles = e.target.files;
    if (newFiles) {
      const updatedFiles = [...selectedFiles, ...Array.from(newFiles)];
      setSelectedFiles(updatedFiles);
      setValue("files", updatedFiles, {
        shouldValidate: true,
        shouldDirty: true,
      });
    }

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleFileDelete = (indexToDelete: number) => {
    const updatedFiles = selectedFiles.filter((_, index) => index !== indexToDelete);
    setSelectedFiles(updatedFiles);
    setValue("files", updatedFiles, {
      shouldValidate: true,
      shouldDirty: true,
    });
  };

  const onSubmit: SubmitHandler<IOnSubmit> = async (data) => {
    const formData = new FormData();

    formData.append("fullname", data.name);
    formData.append("phone", data.phone);
    formData.append("email", data.email);
    formData.append("text", data.text);
    formData.append("form_type", "join_us");
    console.log(formData);

    // try {
    //   const response = await fetch("https://70b0-91-123-151-133.ngrok-free.app/form", {
    //     method: "POST",
    //     headers: {
    //       "ngrok-skip-browser-warning": "true",
    //     },
    //     body: formData,
    //   });

    //   if (!response.ok) {
    //     throw new Error(`Ошибка: ${response.status}`);
    //   }

    //   const result = await response.json();
    //   console.log("Успешно отправлено:", result);
    //   reset();
    // } catch (error) {
    //   console.error("Ошибка при отправке формы:", error);
    // }
    try {
      const response = await axiosInstance.post("/form", formData);
      console.log("Успешно отправлено:", response.data);
      setStateFormSuccess(true);
      reset();
    } catch (error: any) {
      console.error("Ошибка при отправке формы:", error?.response?.data || error.message);
    }
  };

  return (
    <>
      <form className="leave-form" onSubmit={handleSubmit(onSubmit)} noValidate>
        <div className="leave-form-title">
          <p>Ваше сообщение</p>
        </div>
        <div className="leave-form-textarea">
          <textarea
            placeholder="Текст..."
            {...register("text", {
              required: "Text is required",
              validate: (value) => {
                const wordCount = value.trim().split(/\s+/).filter(Boolean).length;
                return wordCount >= 2 || "Minimum 2 words required";
              },
            })}
          />
          {errors.text && <p className="error">{errors.text.message}</p>}
        </div>
        <div className="leave-form-input">
          <input
            type="text"
            placeholder="Полное Имя:"
            {...register("name", {
              required: "Name is required",
              minLength: { value: 2, message: "Minimum 2 characters" },
            })}
          />
          {errors.name && <p className="error">{errors.name.message}</p>}
        </div>
        <div className="leave-form-input">
          <PhoneInputController
            name="phone"
            control={control}
            rules={{ required: "Phone is required" }}
          />
          {errors.phone && <p className="error">{errors.phone.message}</p>}
        </div>
        <div className="leave-form-input">
          <input
            type="email"
            placeholder="Email:"
            {...register("email", {
              required: "Email is required",
              pattern: {
                value: /^\S+@\S+$/i,
                message: "Invalid email address",
              },
            })}
          />
          {errors.email && <p className="error">{errors.email.message}</p>}
        </div>
        <div className="leave-form-footer">
          <div className="leave-form-submit">
            <button type="submit">Отправить</button>
          </div>
          {/* <div
          className={`leave-form-popUp-clip ${popUpBool ? "active" : ""}`}
          onClick={() => setPopUpBool(!popUpBool)}
        >
          <Clip />
        </div> */}
          {/* {errors.files && <p className="error">{errors.files.message}</p>} */}
        </div>
        {/* <div className={`leave-form-popUp ${!popUpBool ? "hidden" : ""}`}>
        <input
          type="hidden"
          {...register("files", {
            validate: (value) =>
              value && value.length > 0 ? true : "At least one file is required",
          })}
        />
        <div
          className="leave-form-popUp-button"
          onDragOver={(e) => e.preventDefault()}
          onDrop={(e) => {
            e.preventDefault();
            const newFiles = Array.from(e.dataTransfer.files);
            if (newFiles.length) {
              const updatedFiles = [...selectedFiles, ...newFiles];
              setSelectedFiles(updatedFiles);
              setValue("files", updatedFiles, {
                shouldValidate: true,
                shouldDirty: true,
              });
            }
          }}
          onClick={() => fileInputRef.current?.click()}
        >
          <input
            type="file"
            multiple
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
          <div className="leave-form-popUp-button-text">
            <p className="first">Перетащите файлы сюда</p>
            <p className="second">или</p>
            <p className="third">Нажмите для выбора файлов</p>
          </div>
          <div className="leave-form-popUp-button-count">
            <p>{selectedFiles.length} из 100</p>
          </div>
        </div>

        {selectedFiles.length > 0 && (
          <>
            <div className="leave-form-popUp-line"></div>
            <div className="leave-form-popUp-items">
              {selectedFiles.map((file, index) => (
                <div className="leave-form-popUp-item" key={index}>
                  <div className="file-svg first">
                    <div className="file-svg second">
                      <File />
                    </div>
                  </div>
                  <p>{file.name}</p>
                  <div className="file-delete" onClick={() => handleFileDelete(index)}>
                    <Delete />
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div> */}
      </form>
      <FormSuccess stateFormSuccess={stateFormSuccess} setStateFormSuccess={setStateFormSuccess} />
    </>
  );
};

export default LeaveForm;
